import clsx from 'clsx';
import React, { useState } from 'react';

import MenuLink from './MenuLink';

interface ExpandableMenuProps {
  children?: React.ReactNode;
  isPro?: boolean;
  name: string;
  onClickCapture?: () => void;
}

const ExpandableMenu = ({ children, isPro, name, onClickCapture }: ExpandableMenuProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div>
      <MenuLink
        name={name}
        as="button"
        isMenuOpen={isMenuOpen}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        onClickCapture={onClickCapture}
        isPro={isPro}
      />
      <div
        className={clsx('overflow-hidden transition-all duration-500 ease-in-out', {
          'max-h-[700px]': isMenuOpen,
          'invisible max-h-0': !isMenuOpen,
        })}
      >
        <div className="mb-16 ml-32 mt-20">{children}</div>
      </div>
    </div>
  );
};

export default ExpandableMenu;
